/**
 * Common enums for the livestock marketplace.
 *
 * These are seller-entered (category, healthFlags) buyer-grade facets that the
 * public browse catalog filters on. Values mirror the backend pgEnums
 * (`MarketplaceOfferCategory`, `MarketplaceHealthFlag`) one-for-one.
 */
/** Production category of an offer — what the herd is *for*. */
export var MarketplaceOfferCategory;
(function (MarketplaceOfferCategory) {
    MarketplaceOfferCategory["FEEDER"] = "FEEDER";
    MarketplaceOfferCategory["BREEDING_FEMALE"] = "BREEDING_FEMALE";
    MarketplaceOfferCategory["BREEDING_BULL"] = "BREEDING_BULL";
    MarketplaceOfferCategory["SLAUGHTER"] = "SLAUGHTER";
    MarketplaceOfferCategory["CALF_WEANER"] = "CALF_WEANER";
    MarketplaceOfferCategory["CULL"] = "CULL";
    MarketplaceOfferCategory["DAIRY"] = "DAIRY";
    MarketplaceOfferCategory["OTHER"] = "OTHER";
})(MarketplaceOfferCategory || (MarketplaceOfferCategory = {}));
/**
 * Brazilian sanitary / certification flags a buyer can require. Filtered with
 * "contains-all" semantics — selecting two means the offer must hold both.
 */
export var MarketplaceHealthFlag;
(function (MarketplaceHealthFlag) {
    MarketplaceHealthFlag["FMD_VACCINATED"] = "FMD_VACCINATED";
    MarketplaceHealthFlag["BRUCELLOSIS_VACCINATED"] = "BRUCELLOSIS_VACCINATED";
    MarketplaceHealthFlag["BRUCELLOSIS_TESTED"] = "BRUCELLOSIS_TESTED";
    MarketplaceHealthFlag["TUBERCULOSIS_TESTED"] = "TUBERCULOSIS_TESTED";
    MarketplaceHealthFlag["GTA_READY"] = "GTA_READY";
})(MarketplaceHealthFlag || (MarketplaceHealthFlag = {}));
/** All category values, ordered — for building filter controls and validators. */
export const MARKETPLACE_OFFER_CATEGORIES = Object.values(MarketplaceOfferCategory);
/** All health-flag values, ordered — for building filter controls and validators. */
export const MARKETPLACE_HEALTH_FLAGS = Object.values(MarketplaceHealthFlag);
/**
 * Cap on the number of breeds a single browse request may filter by. Breeds are
 * free-text (no enum), so the boundary bounds the array to prevent a pathological
 * query; 25 comfortably exceeds any realistic multi-breed search.
 */
export const MARKETPLACE_BREEDS_FILTER_MAX = 25;
//# sourceMappingURL=Common.js.map